module.exports = __webpack_public_path__ + "img/cat_rocket.be835e1c.png";